import { createContext } from 'react';
import { InfolinoQueryQuery } from '../generated/types';

const InfolinoContext = createContext<InfolinoQueryQuery['infolino']>(null);
export default InfolinoContext;
